module.exports = __webpack_public_path__ + "static/media/mggs-t1.167685e3.svg";